module.exports = __webpack_public_path__ + "img/logo-default.a1f45403.png";